import React, { useEffect, useState, createElement } from 'react';
import { StarIcon } from 'lucide-react';
export const ReviewsSection = () => {
  const [widgetLoaded, setWidgetLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    // Detect mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    const widgetId = '95235df587bd90134d4631a3ed8';
    const scriptSrc = `https://cdn.trustindex.io/loader.js?${widgetId}`;
    const anchorId = 'trustindex-anchor';
    // Load script once if not already loaded
    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      document.body.appendChild(script);
    }
    // Aggressive widget detection function
    const findAndRelocateWidget = () => {
      const anchor = document.getElementById(anchorId);
      if (!anchor) return false;
      // Multiple detection strategies
      const selectors = [`div[data-ti-widget*="${widgetId}"]`, 'div[class*="trustindex"]', 'div[class*="ti-widget"]', 'div[id*="trustindex"]', 'div[data-platform-name="google"]'];
      // Try each selector
      for (const selector of selectors) {
        const widgets = document.querySelectorAll(selector);
        for (const widget of widgets) {
          // Only relocate if not already in anchor
          if (!anchor.contains(widget)) {
            console.log('Found Trustindex widget, relocating...');
            anchor.appendChild(widget);
            // Force proper styling
            const widgetElement = widget as HTMLElement;
            widgetElement.style.position = 'static';
            widgetElement.style.display = 'block';
            widgetElement.style.width = '100%';
            widgetElement.style.maxWidth = '100%';
            widgetElement.style.visibility = 'visible';
            widgetElement.style.opacity = '1';
            widgetElement.style.transform = 'none';
            setWidgetLoaded(true);
            return true;
          }
        }
      }
      // Fallback: Look for ANY div added directly to body that might be the widget
      const bodyDivs = Array.from(document.body.children).filter(el => el.tagName === 'DIV' && !el.id && !anchor.contains(el) && el !== anchor && el.textContent?.includes('Google'));
      if (bodyDivs.length > 0) {
        console.log('Found potential widget via fallback, relocating...');
        const widget = bodyDivs[bodyDivs.length - 1] as HTMLElement;
        anchor.appendChild(widget);
        widget.style.position = 'static';
        widget.style.display = 'block';
        widget.style.width = '100%';
        widget.style.maxWidth = '100%';
        widget.style.visibility = 'visible';
        widget.style.opacity = '1';
        setWidgetLoaded(true);
        return true;
      }
      return false;
    };
    // Set up MutationObserver with aggressive settings
    const observer = new MutationObserver(() => {
      if (findAndRelocateWidget()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'id', 'data-ti-widget']
    });
    // Polling fallback - check every 500ms for up to 10 seconds
    let attempts = 0;
    const maxAttempts = 20;
    const pollInterval = setInterval(() => {
      attempts++;
      if (findAndRelocateWidget() || attempts >= maxAttempts) {
        clearInterval(pollInterval);
      }
    }, 500);
    // Cleanup
    return () => {
      observer.disconnect();
      clearInterval(pollInterval);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  // Desktop Version
  if (!isMobile) {
    return <section id="reviews" className="py-16 bg-gradient-to-b from-[#121212] to-[#0a0a0a]" data-id="element-444">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-445">
          <div className="text-center mb-12" data-id="element-446">
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-447">
              <span className="text-[#D6281F]" data-id="element-448">Wat Onze</span>{' '}
              <span className="text-white" data-id="element-449">Klanten Zeggen</span>
            </h2>
            <p className="text-[#CCCCCC] max-w-2xl mx-auto" data-id="element-450">
              Ontdek waarom onze klanten kiezen voor BKCustoms.
            </p>
          </div>
          {/* Widget Container */}
          <div className="mb-8 w-full" data-id="element-451">
            <div id="trustindex-anchor" className="w-full min-h-[400px] relative" style={{
            width: '100%',
            display: 'block',
            position: 'relative'
          }} data-id="element-452">
              {/* Loading skeleton */}
              {!widgetLoaded && <div className="absolute inset-0 flex items-center justify-center" data-id="element-453">
                  <div className="text-center" data-id="element-454">
                    <div className="inline-block w-8 h-8 border-4 border-[#D6281F] border-t-transparent rounded-full animate-spin mb-4" data-id="element-455"></div>
                    <p className="text-white/60 text-sm" data-id="element-456">Reviews laden...</p>
                  </div>
                </div>}
            </div>
          </div>
          {/* CTA Button Only */}
          <div className="mt-8 text-center" data-id="element-457">
            <a href="https://www.google.com/search?q=Bk+Customs+Reviews" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-white bg-[#121212] hover:bg-[#1a1a1a] border border-[#333] hover:border-[#D6281F] px-6 py-3 rounded-md transition-all duration-300" data-id="element-458">
              Bekijk alle reviews op Google
            </a>
          </div>
        </div>
      </section>;
  }
  // Mobile Version
  return <section id="reviews" className="py-12 bg-gradient-to-b from-[#121212] to-[#0a0a0a]" data-id="element-459">
      <div className="max-w-7xl mx-auto px-4" data-id="element-460">
        <div className="text-center mb-10" data-id="element-461">
          <h2 className="text-2xl font-bold mb-4" data-id="element-462">
            <span className="text-[#D6281F]" data-id="element-463">Wat Onze</span>{' '}
            <span className="text-white" data-id="element-464">Klanten Zeggen</span>
          </h2>
          <p className="text-[#CCCCCC] text-sm" data-id="element-465">
            Ontdek waarom onze klanten kiezen voor BKCustoms.
          </p>
        </div>
        {/* Widget Container */}
        <div className="mb-6 w-full" data-id="element-466">
          <div id="trustindex-anchor" className="w-full min-h-[350px] relative" style={{
          width: '100%',
          display: 'block',
          position: 'relative'
        }} data-id="element-467">
            {/* Loading skeleton */}
            {!widgetLoaded && <div className="absolute inset-0 flex items-center justify-center" data-id="element-468">
                <div className="text-center" data-id="element-469">
                  <div className="inline-block w-8 h-8 border-4 border-[#D6281F] border-t-transparent rounded-full animate-spin mb-4" data-id="element-470"></div>
                  <p className="text-white/60 text-sm" data-id="element-471">Reviews laden...</p>
                </div>
              </div>}
          </div>
        </div>
        {/* CTA Button Only */}
        <div className="mt-6 text-center" data-id="element-472">
          <a href="https://www.google.com/search?q=Bk+Customs+Reviews" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-white bg-[#121212] hover:bg-[#1a1a1a] border border-[#333] hover:border-[#D6281F] px-4 py-2 rounded-md transition-all duration-300 text-sm" data-id="element-473">
            Bekijk alle reviews op Google
          </a>
        </div>
      </div>
    </section>;
};